// Dados consolidados do Dashboard Game.
// A distribuicao de partidas segue a regra de negocio informada:
// - Suporte 1: majoritariamente poucas partidas (2 a 5), com excecoes pontuais
// - Demais niveis: majoritariamente entre 10 e 30 partidas, com excecoes abaixo de 10
// Jogadores sem nivel de suporte informado sao considerados Suporte 3.
export const GAME_PLAYERS = [
  { id: 1, nome: 'Angela Maria Galvão Ubirajara', nivelSuporte: 'Suporte 3', partidas: 28 },
  { id: 2, nome: 'Angela Maria Xavier Eloy', nivelSuporte: 'Suporte 1', partidas: 3 },
  { id: 3, nome: 'Antero Martins', nivelSuporte: 'Suporte 3', partidas: 14 },
  { id: 4, nome: 'Arthur', nivelSuporte: 'Suporte 1', partidas: 2 },
  { id: 5, nome: 'Bartolomeu ferreira', nivelSuporte: 'Suporte 3', partidas: 11 },
  { id: 6, nome: 'Cecilia Rondon', nivelSuporte: 'Suporte 3', partidas: 22 },
  { id: 7, nome: 'Darcilei Cavalcânti de Oliveira', nivelSuporte: 'Suporte 3', partidas: 10 },
  { id: 8, nome: 'Dinna', nivelSuporte: 'Suporte 1', partidas: 12 },
  { id: 9, nome: 'Enoque Tavares', nivelSuporte: 'Suporte 3', partidas: 8 },
  { id: 10, nome: 'Fernando José de Moraes Ramos', nivelSuporte: 'Suporte 3', partidas: 17 },
  { id: 11, nome: 'josiane Altino', nivelSuporte: 'Suporte 3', partidas: 9 },
  { id: 12, nome: 'Lucia Maria de Almeida Moraes', nivelSuporte: 'Suporte 1', partidas: 4 },
  { id: 13, nome: 'Luis pontual', nivelSuporte: 'Suporte 3', partidas: 12 },
  { id: 14, nome: 'Luiz Cristo de Oliveira', nivelSuporte: 'Suporte 3', partidas: 30 },
  { id: 15, nome: 'Maria de Piedade Moraes', nivelSuporte: 'Suporte 3', partidas: 16 },
  { id: 16, nome: 'Maria do Carmo Xavier Cardoso Guimarães', nivelSuporte: 'Suporte 3', partidas: 20 },
  { id: 17, nome: 'Maria do Socorro Guimarães', nivelSuporte: 'Suporte 3', partidas: 25 },
  { id: 18, nome: 'Maria do Socorro Teixeira', nivelSuporte: 'Suporte 3', partidas: 18 },
  { id: 19, nome: 'Mary', nivelSuporte: 'Suporte 3', partidas: 21 },
  { id: 20, nome: 'Maurício Viana', nivelSuporte: 'Suporte 3', partidas: 7 },
  { id: 21, nome: 'Núbia Lima', nivelSuporte: 'Suporte 3', partidas: 5 },
  { id: 22, nome: 'Paulina abramof', nivelSuporte: 'Suporte 1', partidas: 3 },
  { id: 23, nome: 'Rita Eurídice de Carvalho', nivelSuporte: 'Suporte 3', partidas: 29 },
  { id: 24, nome: 'tábata', nivelSuporte: 'Suporte 3', partidas: 6 },
  { id: 25, nome: 'Vani Freitas Barbosa', nivelSuporte: 'Suporte 3', partidas: 23 },
];

export const SUPPORT_LEVEL_ORDER = ['Suporte 1', 'Suporte 2', 'Suporte 3', 'Não informado'];

export const SUPPORT_LEVEL_STYLES = {
  'Suporte 1': {
    color: '#f59e0b',
    soft: '#fef3c7',
    text: '#92400e',
    gradient: 'from-amber-400 to-orange-500',
    glow: 'shadow-amber-200',
  },
  'Suporte 2': {
    color: '#0ea5e9',
    soft: '#e0f2fe',
    text: '#075985',
    gradient: 'from-sky-400 to-blue-500',
    glow: 'shadow-sky-200',
  },
  'Suporte 3': {
    color: '#10b981',
    soft: '#d1fae5',
    text: '#065f46',
    gradient: 'from-emerald-400 to-teal-500',
    glow: 'shadow-emerald-200',
  },
  'Não informado': {
    color: '#94a3b8',
    soft: '#f1f5f9',
    text: '#475569',
    gradient: 'from-slate-300 to-slate-400',
    glow: 'shadow-slate-200',
  },
};

export const normalizeSupportLevel = (level) => {
  const normalized = (level || '').trim();
  // Regra de negocio: jogador sem nivel informado e tratado como Suporte 3.
  if (!normalized || normalized.toLowerCase() === 'nível' || normalized.toLowerCase() === 'nivel') {
    return 'Suporte 3';
  }
  return normalized;
};

export const getSupportLevelStyle = (level) =>
  SUPPORT_LEVEL_STYLES[level] || SUPPORT_LEVEL_STYLES['Não informado'];
